export const FILE_PREVIEW_KIND = {
  image: "image",
  pdf: "pdf",
  spreadsheet: "spreadsheet",
  html: "html",
  unsupported: "unsupported",
};

/** What <FilePreviewModal /> can render inline: image, PDF, spreadsheet, HTML, or nothing. */
export const resolveFilePreviewKind = (contentType, fileName) => {
  const type = String(contentType || "").toLowerCase();
  if (type.includes("pdf")) return FILE_PREVIEW_KIND.pdf;
  if (type.startsWith("image/")) return FILE_PREVIEW_KIND.image;
  if (type.includes("spreadsheet") || type.includes("excel")) {
    return FILE_PREVIEW_KIND.spreadsheet;
  }
  if (type.includes("html")) return FILE_PREVIEW_KIND.html;

  const ext = String(fileName || "").split(".").pop().toLowerCase();
  if (ext === "pdf") return FILE_PREVIEW_KIND.pdf;
  if (["png", "jpg", "jpeg"].includes(ext)) return FILE_PREVIEW_KIND.image;
  if (["xls", "xlsx", "xlsm"].includes(ext)) return FILE_PREVIEW_KIND.spreadsheet;
  if (["html", "htm"].includes(ext)) return FILE_PREVIEW_KIND.html;
  return FILE_PREVIEW_KIND.unsupported;
};
